import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import CustomPrintModal2 from './CustomPrintModal2';
import { fetchIngreso } from '../actions/ingresoActions';
import {numeroALetras} from './utils';



const ReciboModal = ({ show, handleClose, nroRecibo }) => {
    const dispatch = useDispatch();
    const [ingreso, setIngreso] = useState(null);
    const [reciboFecha, setReciboFecha] = useState(new Date());
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [printContent, setPrintContent] = useState({ head: [], body: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const loadedReciboRef = useRef(null);

    useEffect(() => {
        if (!show) {
            loadedReciboRef.current = null;
            return;
        }

        if (nroRecibo && loadedReciboRef.current !== nroRecibo) {
            loadedReciboRef.current = nroRecibo;
            cargarDatosRecibo();
        }
    }, [show, nroRecibo]);
    const cargarDatosRecibo = async () => {
        try {
            setLoading(true);
            const actionResult = await dispatch(fetchIngreso(nroRecibo));
            const ingresoData = actionResult.payload;
            setIngreso(ingresoData);
            setReciboFecha(new Date(ingresoData.fecha));
            prepararImpresion(ingresoData);
        } catch (error) {
            setError('Error al cargar los datos del recibo');
        } finally {
            setLoading(false);
        }
    };

    const prepararImpresion = (ingresoData) => {
        const title1 = `RECIBO ${ingresoData.nrorec}`;
        const title2 = `Fecha: ${ingresoData.fecha}`;
        const title3 = `Beneficiario: ${ingresoData.beneficiario}`;
        const title4 = `Concepto: ${ingresoData.concepto}`;
        const total1 = `Total: Bs. ${ingresoData.monto}`;
        const total2 = `Son  ${numeroALetras(ingresoData.monto)}`;
        const content = {
            head: [['Concepto', 'Monto', 'Observaciones']],
            body: ingresoData.detalles.map((detalle) => [
                detalle.concepto,
                detalle.monto,
                detalle.observaciones,
            ]),
        };
        setPrintContent({ title1, title2, title3, title4, total1, total2, content });
        setShowPrintModal(true);
    };

    if (loading) return <div>Cargando...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <CustomPrintModal2
            show={showPrintModal}
            handleClose={() => {
             setShowPrintModal(false);
             handleClose();
            }}
            title1={printContent.title1}
            title2={printContent.title2}
            title3={printContent.title3}
            title4={printContent.title4}
            total1={printContent.total1}
            total2={printContent.total2}
            content={printContent.content}
            copia={false}
        />
    );
};

export default ReciboModal;
